import React from 'react';
import Card from "../../../component/Layout/theme/card";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';





const FreeOrder = ({ freePrice, handleResize }) => {


    const navigation = useNavigate();
    var { t } = useTranslation()



    return (
        <>

            <Card className={handleResize}>

                <div className="bg-white w-full py-5 lg:!min-w-[350px] rounded-lg space-y-5  shadow-md">
                    <div className="space-y-4 ">
                        <h1 className="text-base font-bold text-center ">{t("free")}</h1>
                        <p className="text-lg font-medium text-center ">
                            <span className="">{freePrice && freePrice}</span>
                            <span> {t("toman")}</span>
                        </p>

                        <p className="text-sm font-medium text-center ">{t("yearly")}</p>
                    </div>

                    <div className="flex flex-col gap-3 text-base font-medium text-center">

                        <p className="">
                            {t("create_two_images")}
                        </p>

                        <hr className="" />
                        <p className="" >  {t("ten_visits_per_year")}
                        </p>

                        <hr className="" />
                        <p className="" >{t("business_facilities")}   </p>

                    </div>

                    <div className="flex justify-center ">
                        <button
                            onClick={() => navigation('/addOrder/price_free')}
                            className="p-3 text-sm font-medium text-white bg-green-400 rounded-lg w-52">{t("selection")} </button>
                    </div>
                </div>
            </Card>
        </>
    )


}


export default FreeOrder;